import Layout from '$merchantComponent/layout/home'
import AllOrder from './all-order';
import PreOrder from './pre-order'
import AppointmentOrder from './appointment-order'
import MealPreOrder from './meal-pre-order'
import MealFinishOrder from './meal-finish-order'
import RefundOrder from './refund-order'
import OrderEvaluation from './order-evaluation'

export default commomImport => [{
  path: `/order-manager/`,
  name: 'order-manager',
  meta: {
    title: 'store.orderManager',
    icon: 'el-icon-s-order'
  },
  component: Layout,
  children: [

    ...AllOrder(commomImport),
    ...PreOrder(commomImport),
    ...AppointmentOrder(commomImport),
    ...MealPreOrder(commomImport),
    ...MealFinishOrder(commomImport),
    ...RefundOrder(commomImport),
    ...OrderEvaluation(commomImport)
  ]
}];
